module.exports = __webpack_public_path__ + "static/media/vivo4.e01e15b1.jpeg";